import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@medflex/components/stories/Button';
import { format } from '@medflex/i18n';
import SettingsBox from '@medflex/components/stories/SettingsBox';
import Badge, { KINDS } from '@medflex/components/stories/Badge';
import { FEATURE_KEYS } from '@medflex/utils/subscriptionEnums';
import { PlusCircleIcon } from '@heroicons/react/24/outline';
import useFeatures from '../../hooks/useFeatures';
import { STATUS } from '../../store/models/subscription';
import usePhysicianStatusEdit from '../../hooks/usePhysicianStatusEdit';
import useModal from '../../hooks/useModal';
import useSubscription from '../../hooks/useSubscription';
import { MODALS } from '../../hooks/useIsModal';

const PhysicianStatusModule = () => {
  const { open } = useModal();
  const { status, statusSetAt } = usePhysicianStatusEdit();
  const { t } = useTranslation('physician');
  const [physicianStatusFeature] = useFeatures([FEATURE_KEYS.PHYSICIAN_STATUS]);
  const { status: subscriptionStatus } = useSubscription();

  const handleCreate = () => {
    if (physicianStatusFeature.active) {
      open({ modal: MODALS.status });
      return;
    }

    open({ modal: MODALS.featureUpgradePhysicianStatus });
  };

  return (
    <div data-component="PhysicianStatusModule" className="flex flex-col">
      <header className="mb-6 flex items-center">
        <h2 className="text-2xl font-semibold">{t('PhysicianStatusModule.title')}</h2>
      </header>
      <p className="mb-6">{t('PhysicianStatusModule.description', { allowHtml: true })}</p>
      {subscriptionStatus === STATUS.LOADED &&
        (physicianStatusFeature.active && status ? (
          <SettingsBox
            title={format(statusSetAt, 'DD.MM.YYYY')}
            canEdit
            canDelete
            truncate
            onEdit={() => open({ modal: 'status' })}
            onDelete={() => open({ modal: 'statusDelete' })}
          >
            <p className="truncate">{status}</p>
          </SettingsBox>
        ) : (
          <Button onClick={handleCreate} className="hover:no-underline" kind="link">
            <PlusCircleIcon className="mr-2 h-6 w-6" />
            <span className="hover:underline">{t('PhysicianStatusModule.add_status')}</span>
            {!physicianStatusFeature.active && (
              <Badge className="ml-2 leading-normal" kind={KINDS.SIGNAL}>
                Upgrade
              </Badge>
            )}
          </Button>
        ))}
    </div>
  );
};

export default PhysicianStatusModule;
